import { useState, useEffect } from 'react';
import { productsAPI } from '../../services/api';
import toast from 'react-hot-toast';

const fmt = v => `R$ ${parseFloat(v||0).toFixed(2).replace('.',',')}`;
const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };

export default function StockPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [search, setSearch]     = useState('');
  const [showForm, setShowForm] = useState(false);
  const [showMove, setShowMove] = useState(null);
  const [form, setForm]         = useState({ name:'', description:'', sku:'', unit:'un', cost_price:'', sale_price:'', stock_quantity:0, min_stock:5, active:1 });
  const [editing, setEditing]   = useState(null);
  const [move, setMove]         = useState({ type:'entrada', quantity:'', notes:'' });

  const load = async () => {
    setLoading(true);
    try {
      const r = await productsAPI.list({ search, limit:100 });
      setProducts(r.data.data || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await productsAPI.update(editing.id, form);
      else         await productsAPI.create(form);
      toast.success(editing ? 'Produto atualizado!' : 'Produto criado!');
      setShowForm(false); setForm({ name:'', description:'', sku:'', unit:'un', cost_price:'', sale_price:'', stock_quantity:0, min_stock:5, active:1 }); setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const startEdit = (p) => { setEditing(p); setForm({ name:p.name, description:p.description||'', sku:p.sku||'', unit:p.unit||'un', cost_price:p.cost_price||'', sale_price:p.sale_price||'', stock_quantity:p.stock_quantity||0, min_stock:p.min_stock||5, active:p.active??1 }); setShowForm(true); };

  const del = async (id) => {
    if (!window.confirm('Remover produto?')) return;
    try { await productsAPI.delete(id); toast.success('Removido!'); load(); }
    catch { toast.error('Erro.'); }
  };

  const saveMovement = async (e) => {
    e.preventDefault();
    try {
      await productsAPI.movement(showMove.id, { ...move, quantity: parseInt(move.quantity) });
      toast.success('Movimentação registrada!');
      setShowMove(null); setMove({ type:'entrada', quantity:'', notes:'' }); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const lowStock = products.filter(p => p.is_low_stock);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Estoque</h1>
        <button onClick={()=>{setShowForm(true);setEditing(null);setForm({ name:'', description:'', sku:'', unit:'un', cost_price:'', sale_price:'', stock_quantity:0, min_stock:5, active:1 })}}
          style={{ background:'#2563EB', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer' }}>
          + Novo Produto
        </button>
      </div>

      {lowStock.length > 0 && (
        <div style={{ background:'#FEF3C7', border:'1px solid #FCD34D', borderRadius:10, padding:'12px 16px', marginBottom:16, display:'flex', gap:8, alignItems:'center' }}>
          <span style={{ fontSize:'1.2rem' }}>⚠️</span>
          <span style={{ fontWeight:600, color:'#92400E' }}>
            {lowStock.length} produto{lowStock.length>1?'s':''} com estoque baixo: {lowStock.map(p=>p.name).join(', ')}
          </span>
        </div>
      )}

      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar produto..."
        style={{ ...inp, marginBottom:16, padding:'10px 16px' }} />

      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E5E7EB', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:700 }}>
          <thead><tr style={{ background:'#F8FAFC', borderBottom:'1px solid #E5E7EB' }}>
            {['Produto','SKU','Estoque','Mín.','Custo','Venda','Status','Ações'].map(h=>(
              <th key={h} style={{ padding:'12px 16px', textAlign:'left', fontSize:'.8rem', fontWeight:600, color:'#6B7280' }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={8} style={{ padding:40, textAlign:'center', color:'#9CA3AF' }}>Carregando...</td></tr>
            : products.length === 0 ? <tr><td colSpan={8} style={{ padding:40, textAlign:'center', color:'#9CA3AF' }}>Nenhum produto.</td></tr>
            : products.map(p => (
              <tr key={p.id} style={{ borderBottom:'1px solid #F1F5F9', background: p.is_low_stock ? '#FFFBEB' : '#fff' }}>
                <td style={{ padding:'12px 16px' }}>
                  <div style={{ fontWeight:600 }}>{p.name}</div>
                  {p.description && <div style={{ fontSize:'.75rem', color:'#9CA3AF' }}>{p.description}</div>}
                </td>
                <td style={{ padding:'12px 16px', fontSize:'.85rem', color:'#6B7280' }}>{p.sku||'—'}</td>
                <td style={{ padding:'12px 16px', fontWeight:700, color: p.is_low_stock?'#DC2626':'#059669' }}>
                  {p.stock_quantity} {p.unit}
                </td>
                <td style={{ padding:'12px 16px', fontSize:'.85rem', color:'#9CA3AF' }}>{p.min_stock}</td>
                <td style={{ padding:'12px 16px', fontSize:'.85rem' }}>{p.cost_price ? fmt(p.cost_price) : '—'}</td>
                <td style={{ padding:'12px 16px', fontSize:'.85rem', fontWeight:600 }}>{p.sale_price ? fmt(p.sale_price) : '—'}</td>
                <td style={{ padding:'12px 16px' }}>
                  <span style={{ background:p.active?'#D1FAE5':'#F3F4F6', color:p.active?'#065F46':'#6B7280', borderRadius:6, padding:'2px 8px', fontSize:'.7rem', fontWeight:600 }}>
                    {p.active ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td style={{ padding:'12px 16px' }}>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={()=>setShowMove(p)} style={{ background:'#F0FDF4', color:'#059669', border:'none', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:'.75rem', fontWeight:600 }}>±Estoque</button>
                    <button onClick={()=>startEdit(p)} style={{ background:'#EFF6FF', color:'#2563EB', border:'none', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:'.75rem', fontWeight:600 }}>Editar</button>
                    <button onClick={()=>del(p.id)} style={{ background:'#FEF2F2', color:'#DC2626', border:'none', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:'.75rem', fontWeight:600 }}>✕</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:540, maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>{editing?'Editar':'Novo'} Produto</h3>
            <form onSubmit={save}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={lbl}>Nome *</label>
                  <input value={form.name} onChange={e=>set('name',e.target.value)} required style={inp} />
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={lbl}>Descrição</label>
                  <textarea value={form.description} onChange={e=>set('description',e.target.value)} rows={2} style={{ ...inp, resize:'vertical' }} />
                </div>
                <div>
                  <label style={lbl}>SKU / Código</label>
                  <input value={form.sku} onChange={e=>set('sku',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Unidade</label>
                  <select value={form.unit} onChange={e=>set('unit',e.target.value)} style={inp}>
                    {['un','kg','lt','m','cx','pc'].map(u=><option key={u} value={u}>{u}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Preço de custo</label>
                  <input type="number" step="0.01" min="0" value={form.cost_price} onChange={e=>set('cost_price',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Preço de venda</label>
                  <input type="number" step="0.01" min="0" value={form.sale_price} onChange={e=>set('sale_price',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Estoque atual</label>
                  <input type="number" value={form.stock_quantity} onChange={e=>set('stock_quantity',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Estoque mínimo</label>
                  <input type="number" value={form.min_stock} onChange={e=>set('min_stock',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Status</label>
                  <select value={form.active} onChange={e=>set('active',Number(e.target.value))} style={inp}>
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                  </select>
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showMove && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:420 }}>
            <h3 style={{ fontWeight:700, marginBottom:4 }}>Movimentação de Estoque</h3>
            <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:20 }}>Produto: <strong>{showMove.name}</strong> · Atual: <strong>{showMove.stock_quantity} {showMove.unit}</strong></p>
            <form onSubmit={saveMovement}>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Tipo</label>
                <select value={move.type} onChange={e=>setMove(m=>({...m,type:e.target.value}))} style={inp}>
                  <option value="entrada">Entrada (+)</option>
                  <option value="saida">Saída (−)</option>
                  <option value="ajuste">Ajuste</option>
                </select>
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Quantidade *</label>
                <input type="number" min="1" value={move.quantity} onChange={e=>setMove(m=>({...m,quantity:e.target.value}))} required style={inp} />
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Observações</label>
                <input value={move.notes} onChange={e=>setMove(m=>({...m,notes:e.target.value}))} style={inp} />
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <button type="button" onClick={()=>setShowMove(null)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#059669', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Registrar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
